import { fetchWithChatFeedback } from './chatFeedbackRequired';

export interface ContactChatMessage {
  id: string; sequence: number; sender_email: string; body: string; created_at: string; client_message_id: string;
}
export interface ContactConversation {
  conversation_id: string; viewer_email: string; initiator_email: string;
  recipient: { person_name: string; email: string; provided_by_initiator: boolean };
  counterpart: { person_name: string; email: string };
  context: { assigned_unit: string; unit_id: string; role_id: string; contact_id: string; displayed_revision: string; context_kind: string; context_id?: string };
  last_activity: string | null; unread_count: number;
  delivery: { status: string; can_resend: boolean };
}
export interface ContactChatPage { conversation: ContactConversation; messages: ContactChatMessage[]; has_earlier: boolean }
export interface ResolveContactChat {
  role_id: string; contact_id: string; displayed_revision: string;
  person_name?: string; email?: string; confirmed_individual?: boolean;
  context_kind?: string; context_id?: string;
}
export class ContactChatError extends Error {
  constructor(public status: number, public code?: string) { super('Conversation unavailable. Please retry.'); }
}
async function request<T>(path: string, body?: unknown): Promise<T> {
  const response = await fetchWithChatFeedback(`${process.env.REACT_APP_API_URL || ''}/api/ra-contact-chat${path}`, {
    method: body === undefined ? 'GET' : 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' }, ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (response.status === 401) window.dispatchEvent(new Event('auth-expired'));
  const result = await response.json().catch(() => null);
  if (!response.ok || result?.success !== true || !result?.data) throw new ContactChatError(response.status, result?.error_code);
  return result.data as T;
}
export const resolveContactChat = (body: ResolveContactChat) => request<ContactConversation>('/conversations/resolve', body);
export const listContactChats = () => request<{conversations: ContactConversation[]; unread_count: number}>('/conversations');
export const getContactChat = (id: string, before?: number) => request<ContactChatPage>(`/conversations/${encodeURIComponent(id)}/messages${before ? `?before_sequence=${before}` : ''}`);
export const sendContactChat = (id: string, body: string, clientMessageId: string) => request<{message:ContactChatMessage;conversation:ContactConversation}>(`/conversations/${encodeURIComponent(id)}/messages`, {body,client_message_id:clientMessageId});
export const readContactChat = (id: string, through: number) => request<ContactConversation>(`/conversations/${encodeURIComponent(id)}/read`, {through_sequence:through});
export const resendContactChatInvitation = (id: string) => request<ContactConversation>(`/conversations/${encodeURIComponent(id)}/invitation/resend`, {});
export const contactChatChanged = () => window.dispatchEvent(new Event('contact-chat:changed'));
export const openPeopleChat = (id: string) => window.dispatchEvent(new CustomEvent('contact-chat:open',{detail:{conversationId:id}}));
export const newChatMessageId = () => globalThis.crypto?.randomUUID?.() || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {const n=Math.floor(Math.random()*16);return(c==='x'?n:(n&3)|8).toString(16);});
